//cardInfoPopup
(function() {
    $(window).ready(function() {
        var cardMember = {
            init: function() {
                var self = this;
                self.setting();
                self.bindEvents();
            },

            setting: function() {
                var self = this;
                self.$contents = $('div.contents.membership');
                self.$cardInfoPopup = $('#cardInfoPopup');
                self.$btnBack = $('.mobile-nav-wrap').find('.btn-back'); //BTOCSITE-6130
                self.$cardTab = $('.tabs-wrap.border-type.left.ui_tab');
            },

            // CSR-15473 탭 선택 시 중앙정렬 적용
            // li에 on 클래스가 붙는 탭(.tabs, overflow-x:auto 로 자체 스크롤됨)이 화면 중앙에 오도록 scrollLeft 이동
            centerActiveTab: function($tabWrap) {
                var $scroller = $tabWrap.find('> .tabs');
                var $active = $scroller.children('li.on');
                if (!$scroller.length || !$active.length) return;

                var wrapWidth = $scroller[0].clientWidth;
                var scrollWidth = $scroller[0].scrollWidth;
                var maxScrollLeft = scrollWidth - wrapWidth;
                if (maxScrollLeft <= 0) return; // 스크롤이 필요 없는 경우

                var activeCenter = $active[0].offsetLeft + $active[0].offsetWidth / 2;
                var destLeft = Math.round(activeCenter - wrapWidth / 2);
                destLeft = Math.min(maxScrollLeft, Math.max(0, destLeft));

                $scroller.stop().animate({ scrollLeft: destLeft }, 300);
            },

            bindEvents: function() {
                var self = this;

                self.$cardTab.on('tabchange', function(e, _obj) {
                    self.centerActiveTab($(this));
                });

                //카테고리탭
                self.$contents.on('click', 'div.application-btn a', function(e){
                    e.preventDefault();
                    self.$cardInfoPopup.vcModal({opener:$(this)});
                });

                self.$cardInfoPopup.on('click', 'footer.pop-footer button:not(.ui_modal_close)', function(e) {
                    var url = self.$cardInfoPopup.attr('data-url');
                    if(!(!url)) {
                        location.href = url;
                    }
                });

                //BTOCSITE-6130 렌탈 청약시 납부정보 카드혜택 팝업 오류 //BTOCSITE-5938-326 [모니터링] 케어솔루션 할인 혜택 > '제휴카드 할인 혜택 자세히 보기' 이전버튼 반응 없음
                self.$btnBack.on('click', function(e){
                    var paramFlag = lgkorUI.getParameterByName("careSolution");
                    var paramFlagDisc = lgkorUI.getParameterByName("CareDiscount");
                    
                    if( paramFlag != undefined && paramFlag != "" || paramFlagDisc != undefined && paramFlagDisc != "") {
                        if( paramFlag == "true" || paramFlag == true || paramFlagDisc == "Y" ) {
                            e.preventDefault();
                            window.close();
                            window.history.back(); //BTOCSITE-5938-429 : 팝업이 아닌경우
                        }
                    } 
                });
            }
        };

        cardMember.init();
    });

})();
